import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import advancedPlannerReducer from 'src/store/reducers/advancedPlannerReducer';
import apiClientsReducer from 'src/store/reducers/apiClientsReducer';
import appConfigReducer from 'src/store/reducers/appConfigReducer';
import argosEventsReducer from 'src/store/reducers/argosEventsReducer';
import calendarEventsLogReducer from 'src/store/reducers/calendarEventsLogReducer';
import calendarReducer from 'src/store/reducers/calendarReducer';
import commentsReducer from 'src/store/reducers/commentsReducer';
import compensationsReducer from 'src/store/reducers/compensationsReducer';
import compensationProductsReducer from 'src/store/reducers/compenstaionProductsReducer';
import configurationsReducer from 'src/store/reducers/configurationsReducer';
import confirmWorkHoursReportReducer from 'src/store/reducers/confirmWorkHoursReportReducer';
import confirmationsReducer from 'src/store/reducers/confirmationsReducer';
import confirmatorsReducer from 'src/store/reducers/confirmatorsAdministrationReducer';
import departmentsReducer from 'src/store/reducers/departmentsReducer';
import detailedSummaryReportReducer from 'src/store/reducers/detailedSummaryReportReducer';
import devicesReducer from 'src/store/reducers/devicesReducer';
import employeesContracts from 'src/store/reducers/employeesContractsReducer';
import employeesReducer from 'src/store/reducers/employeesReducer';
import excelReducer from 'src/store/reducers/excelReducer';
import flexibleWorkTimeMonitoringReducer from 'src/store/reducers/flexibleWorkTimeMonitoringReducer';
import formFilterReducer from 'src/store/reducers/formFiltersReducer';
import freeTime from 'src/store/reducers/freeTimeReducer';
import helpReducer from 'src/store/reducers/helpReducer';
import importFromArgosReducer from 'src/store/reducers/importFromArgosReducer';
import importUsersReducer from 'src/store/reducers/importUsersReducer';
import jobProfilesReducer from 'src/store/reducers/jobProfilesReducer';
import jobsReducer from 'src/store/reducers/jobsReducer';
import lawChecksReducer from 'src/store/reducers/lawChecksReducer';
import lawReducer from 'src/store/reducers/lawReducer';
import machineTimesReducer from 'src/store/reducers/machineTimesReducer';
import mainReportReducer from 'src/store/reducers/mainReportReducer';
import motReducer from 'src/store/reducers/motReducer';
import mu4Reducer from 'src/store/reducers/mu4Reducer';
import offlineLockCardsReducer from 'src/store/reducers/offlineLockCardsReducer';
import pageReducer from 'src/store/reducers/pageReducer';
import passingGroupsReducer from 'src/store/reducers/passingGroupsReducer';
import pdfReducer from 'src/store/reducers/pdfReducer';
import personalConfigurationReducer from 'src/store/reducers/personalConfigurationReducer';
import plannerReducer from 'src/store/reducers/plannerReducer';
import plannerRequestsReducer from 'src/store/reducers/plannerRequestsReducer';
import professionsReducer from 'src/store/reducers/professionsReducer';
import projectsByJobsReducer from 'src/store/reducers/projectsByJobsReducer';
import projectsReducer from 'src/store/reducers/projectsReducer';
import renewStandardTimesReducer from 'src/store/reducers/renewStandardTimesReducer';
import requestSubTypesReducer from 'src/store/reducers/requestSubTypesReducer';
import requestTypesReducer from 'src/store/reducers/requestTypesReducer';
import rewardsReducer from 'src/store/reducers/rewardsReducer';
import serviceWorkerReducer from 'src/store/reducers/ServiceWorkerReducer';
import skillsReducer from 'src/store/reducers/skillsReduces';
import slipTimesReducer from 'src/store/reducers/slipTimesReducer';
import statementsReducer from 'src/store/reducers/statementsReducer';
import tableHistoryReducer from 'src/store/reducers/tableHistoryReducer';
import timeTableReducer from 'src/store/reducers/timeTableReducer';
import timeRateSystemsReducer from 'src/store/reducers/timeRateSystemsReducer';
import toastrReducer from 'src/store/reducers/toastrReducer';
import trackingReducer from 'src/store/reducers/trackingReducer';
import tvGraphReducer from 'src/store/reducers/tvGraphReducer';
import tvJobsReducer from 'src/store/reducers/tvJobsReducer';
import tvReducer from 'src/store/reducers/tvReducer';
import unscheduledWorkReportReducer from 'src/store/reducers/unscheduledWorkReportReducer';
import userInfoReducer from 'src/store/reducers/userInfoReducer';
import userRightReducer from 'src/store/reducers/userRightReducer';
import usersReducer from 'src/store/reducers/usersReducer';
import vacationsReducer from 'src/store/reducers/vacationsReducer';
import wccMotReducer from 'src/store/reducers/wccMotReducer';
import wccReducer from 'src/store/reducers/wccReducer';
import workAndAbsenceReducer from 'src/store/reducers/workAndAbsenceReducer';
import workDayEventsReducer from 'src/store/reducers/workDayEventsReducer';
import workGroupsReducer from 'src/store/reducers/workGroupsReducer';
import workHoursExportReducer from 'src/store/reducers/workHoursExportReducer';
import workShiftsReducer from 'src/store/reducers/workShiftsReducer';
import workSiteReducer from 'src/store/reducers/workSiteReducer';
import workTimeSummaryReducer from 'src/store/reducers/workTimeSummaryReducer';
import workTimesByDaysReducer from 'src/store/reducers/workTimesByDaysReducer';
import workTimesInPeriodByJobsReducer from 'src/store/reducers/workTimesInPeriodByJobsReducer';
import workTimesReducer from 'src/store/reducers/workTimesReducer';
import worksInDepartmentsReducer from 'src/store/reducers/worksInDepartmentsReducer';
import worksInOtherDepartmentsReducer from 'src/store/reducers/worksInOtherDepartmentsReducer';
import worktimeTypesReducer from 'src/store/reducers/WorktimeTypesReducer';
import entityInfoReducer from 'src/store/reducers/entityInfoReducer';
import translationReducer from 'src/store/reducers/translationReducer';
import lawReportReducer from 'src/store/reducers/lawReportReducer';
import lunchPolicyReducer from 'src/store/reducers/lunchPolicyReducer';
import eventConfirmationsReducer from 'src/store/reducers/eventConfirmationsReducer';
import plannerPolicyReducer from 'src/store/reducers/plannerPolicyReducer';

const rootReducer = (state = {}, action) => ({
  advancedPlanner: advancedPlannerReducer(state.advancedPlanner, action),
  apiClients: apiClientsReducer(state.apiClients, action),
  appConfig: appConfigReducer(state.appConfig, action),
  argosEvents: argosEventsReducer(state.argosEvents, action),
  calendar: calendarReducer(state.calendar, action),
  calendarEventsLog: calendarEventsLogReducer(state.calendarEventsLog, action),
  comments: commentsReducer(state.comments, action),
  compensations: compensationsReducer(state.compensations, action),
  compensationProducts: compensationProductsReducer(state.compensationProducts, action),
  configurations: configurationsReducer(state.configurations, action),
  confirmWorkhoursReport: confirmWorkHoursReportReducer(state.confirmWorkhoursReport, action),
  confirmations: confirmationsReducer(state.confirmations, action),
  confirmators: confirmatorsReducer(state.confirmators, action),
  departments: departmentsReducer(state.departments, action),
  detailedSummaryReport: detailedSummaryReportReducer(state.detailedSummaryReport, action),
  devices: devicesReducer(state.devices, action),
  employees: employeesReducer(state.employees, action),
  employeesContracts: employeesContracts(state.employeesContracts, action),
  entityInfo: entityInfoReducer(state.entityInfo, action),
  eventConfirmations: eventConfirmationsReducer(state.eventConfirmations, action),
  excel: excelReducer(state.excel, action),
  flexibleWorkTimeMonitoring: flexibleWorkTimeMonitoringReducer(state.flexibleWorkTimeMonitoring, action),
  form: formReducer(state.form, action),
  formFilters: formFilterReducer(state.formFilters, action),
  freeTime: freeTime(state.freeTime, action),
  help: helpReducer(state.help, action),
  importFromArgos: importFromArgosReducer(state.importFromArgos, action),
  importUsers: importUsersReducer(state.importUsers, action),
  jobProfiles: jobProfilesReducer(state.jobProfiles, action),
  jobs: jobsReducer(state.jobs, action),
  law: lawReducer(state.law, action),
  lawChecks: lawChecksReducer(state.lawChecks, action),
  lawReport: lawReportReducer(state.lawReport, action),
  lunchPolicy: lunchPolicyReducer(state.lunchPolicy, action),
  machineTimes: machineTimesReducer(state.machineTimes, action),
  mainReport: mainReportReducer(state.mainReport, action),
  mot: motReducer(state.mot, action),
  mu4: mu4Reducer(state.mu4, action),
  offlineLockCards: offlineLockCardsReducer(state.offlineLockCards, action),
  pages: pageReducer(state.pages, action),
  passingGroups: passingGroupsReducer(state.passingGroups, action),
  pdf: pdfReducer(state.pdf, action),
  personalConfiguration: personalConfigurationReducer(state.personalConfiguration, action),
  planner: plannerReducer(state.planner, action),
  plannerPolicy: plannerPolicyReducer(state.plannerPolicy, action),
  plannerRequests: plannerRequestsReducer(state.plannerRequests, action),
  professions: professionsReducer(state.professions, action),
  projects: projectsReducer(state.projects, action),
  projectsByJobs: projectsByJobsReducer(state.projectsByJobs, action),
  renewStandardTimes: renewStandardTimesReducer(state.renewStandardTimes, action),
  requestSubTypes: requestSubTypesReducer(state.requestSubTypes, action),
  requestTypes: requestTypesReducer(state.requestTypes, action),
  rewards: rewardsReducer(state.rewards, action),
  routing: routerReducer(state.routing, action),
  serviceWorker: serviceWorkerReducer(state.serviceWorker, action),
  skills: skillsReducer(state.skills, action),
  slipTimes: slipTimesReducer(state.slipTimes, action),
  statements: statementsReducer(state.statements, action),
  tableHistory: tableHistoryReducer(state.tableHistory, action),
  timeTable: timeTableReducer(state.timeTable, action),
  timeRateSystems: timeRateSystemsReducer(state.timeRateSystems, action),
  toastr: toastrReducer(state.toastr, action, state.personalConfiguration),
  tracking: trackingReducer(state.tracking, action),
  translation: translationReducer(state.translation, action),
  tv: tvReducer(state.tv, action),
  tvGraph: tvGraphReducer(state.tvGraph, action),
  tvJobs: tvJobsReducer(state.tvJobs, action),
  unscheduledWorkReport: unscheduledWorkReportReducer(state.unscheduledWorkReport, action),
  userInfo: userInfoReducer(state.userInfo, action),
  userRight: userRightReducer(state.userRight, action),
  users: usersReducer(state.users, action),
  vacations: vacationsReducer(state.vacations, action),
  wcc: wccReducer(state.wcc, action),
  wccMot: wccMotReducer(state.wccMot, action),
  workAndAbsence: workAndAbsenceReducer(state.workAndAbsence, action),
  workDayEvents: workDayEventsReducer(state.workDayEvents, action),
  workGroups: workGroupsReducer(state.workGroups, action),
  workHoursExport: workHoursExportReducer(state.workHoursExport, action),
  workShifts: workShiftsReducer(state.workShifts, action),
  workSites: workSiteReducer(state.workSites, action),
  workTimeSummary: workTimeSummaryReducer(state.workTimeSummary, action),
  workTimes: workTimesReducer(state.workTimes, action),
  workTimesByDays: workTimesByDaysReducer(state.workTimesByDays, action),
  workTimesInPeriodByJobs: workTimesInPeriodByJobsReducer(state.workTimesInPeriodByJobs, action),
  worksInDepartments: worksInDepartmentsReducer(state.worksInDepartments, action),
  worksInOtherDepartments: worksInOtherDepartmentsReducer(state.worksInOtherDepartments, action),
  worktimeTypes: worktimeTypesReducer(state.worktimeTypes, action)
});

export default rootReducer;
